import { ExtendedLink as Link } from 'components/common/LocaleLink';
import { YoutubeEmbed } from './YoutubeEmbed';
import getYouTubeID from 'get-youtube-id';
import urlBuilder from '@sanity/image-url';
import { getLocalizedContent } from 'helpers/Localization';
import React from 'react';
import { Quote } from './Quote';

export const serializers = {
    marks: {
        link: ({ mark, children }) => {
            const { href, internal } = mark;
            return internal ? (
                <Link to={href} className="tw-text-primary hover:tw-text-primary-hover">
                    {children}
                </Link>
            ) : (
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );
        }
    },
    types: {
        youtube: ({ node }) => {
            const { url } = node;
            const id = getYouTubeID(url);
            return <YoutubeEmbed videoId={id} classNames="tw-w-full tw-aspect-video" />;
        },
        blockCallout: ({ node }) => {
            const { text } = node;
            return <div className="tw-bg-[#C7E7E7] tw-rounded tw-p-24 tw-my-48">{text}</div>;
        },
        blockQuote: ({ node }) => {
            const { text } = node;
            return <Quote text={text} />;
        },
        imageWithCaption: (props) => {
            const { href, internal } = props.node;
            const urlFor = (source) =>
                urlBuilder({
                    projectId: props.options.projectId,
                    dataset: props.options.dataset
                }).image(source);

            const figure = (
                <figure>
                    <img
                        src={urlFor(props.node.image).width(720).url()}
                        style={{ width: '100%', padding: '0px', maxHeight: 'none' }}
                        alt={getLocalizedContent(props.node.caption)}
                    />
                    <figcaption
                        style={{
                            captionSide: 'bottom',
                            marginTop: '6px',
                            fontStyle: 'italic',
                            fontSize: '14px'
                        }}
                    >
                        {getLocalizedContent(props.node.caption)}
                    </figcaption>
                </figure>
            );

            if (href) {
                return internal ? (
                    <Link className="imageLink" to={href}>
                        {figure}
                    </Link>
                ) : (
                    <a className="imageLink" href={href} target="_blank" rel="noopener noreferrer">
                        {figure}
                    </a>
                );
            }

            return figure;
        }
    }
};
